import {
    usePostV1UploadUploadDocumentsRequest,
    usePostV1UploadUploadRequestComplete,
} from '../api/generated/endpoint';
import { BlobServiceClient } from '@azure/storage-blob';
import useGenericErrorToast from './useGenericErrorToast';
import { useState } from 'react';

export const useFileUpload = () => {
    const { mutate: uploadDocumentsRequest } =
        usePostV1UploadUploadDocumentsRequest();
    const showGenericErrorToast = useGenericErrorToast();
    const { mutate: postUploadRequestComplete } =
        usePostV1UploadUploadRequestComplete();

    const [uploadProgress, setUploadProgress] = useState(0);

    const uploadFilesToBlob = async (sasUrl: string, files: any) => {
        try {
            const containerClient = new BlobServiceClient(
                sasUrl
            ).getContainerClient('');
            let uploadedCount = 0;

            for (const file of files) {
                const blobClient = containerClient.getBlockBlobClient(
                    file.name
                );
                console.log(`Uploading ${file.name}...`);
                await blobClient.uploadData(file.originFile);
                console.log(`Uploaded ${file.name} successfully`);

                // Update progress
                uploadedCount += 1;
                setUploadProgress(uploadedCount);
            }
            return true;
        } catch (error) {
            console.error('Error uploading files:', error);
            return false;
        }
    };

    const uploadFiles = async (files: File[], processId: number = 1) => {
        return new Promise((resolve, reject) => {
            const uploadRequest = {
                processId: processId,
            };

            uploadDocumentsRequest(
                { data: uploadRequest },
                {
                    onSuccess: async (response) => {
                        const uploadSuccess = await uploadFilesToBlob(
                            response.uploadUrl,
                            files
                        );
                        if (uploadSuccess) {
                            const uploadRequestCompleteModel = {
                                uploadRequestId: response.uploadRequestId, // Ensure this comes from the response
                                documentCount: files.length,
                            };
                            await postUploadRequestComplete({
                                data: uploadRequestCompleteModel,
                            });
                            resolve(true);
                        } else {
                            reject(new Error('Upload failed'));
                        }
                    },
                    onError: (error) => {
                        showGenericErrorToast(error);
                        reject(error);
                    },
                }
            );
        });
    };

    return { uploadFiles, uploadProgress };
};
